import type { EditorMessage } from "./RendererBridgePort";
import { isWholeNumber } from "./wholeNumber";

// The editor's readAfter: the highest cache version it has seen, 0 before one, which the renderer's reads then wait
// for. Its cacheSeq must be a whole number of 0 or more, as the contract says; it is read from the message rather than
// taken as sent, so a fraction, text or true is refused.
function parse(message: Readonly<Record<string, unknown>>): EditorMessage<"readAfter"> {
  const cacheSeq = message["cacheSeq"];
  // PORT-DEVIATION: Assets/Modules/RendererBridge/Scripts/Internal/EditorReadAfter.cs:18-24 — a whole number past 2^53 is a long in C# but has no exact JavaScript number, so it is refused here.
  if (!isWholeNumber(cacheSeq)) throw new Error("readAfter's cacheSeq is not a whole number of 0 or more");
  return { type: "readAfter", cacheSeq };
}

// The editor's version as it opened the renderer, from the renderer's own address (?readAfter=<cacheSeq>): digits only,
// as the editor writes it, else null, as for an address without one. A floor only, for the reads before rendererLoaded.
function fromAddress(href: string): number | null {
  let value: string | null;
  try {
    value = new URL(href).searchParams.get("readAfter");
  } catch {
    return null;
  }
  if (value === null || !/^\d+$/.test(value)) return null;
  const cacheSeq = Number(value);
  return isWholeNumber(cacheSeq) ? cacheSeq : null;
}

export const EditorReadAfter = { parse, fromAddress } as const;
